
const SGGameScenes = {
    FREE_SPINS_SUMMARY: "freespinssummary",
    FREE_SPINS_WIN: "freespinswin",
    FREE_SPINS_RETRIGGER: "freespinsretrigger",

    BIG_WIN: "bigWin",
    MEGA_BIG_WIN: "megaBigWin",
    HUGE_BIG_WIN: "hugeBigWin",

    WIN_RESPIN: "winRespin"
};

export default SGGameScenes;
